
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { ISocialSharingData } from '../../store/SocialSharing'
import { globalLabelAsString } from '../../shared/general/services/StoreService'
import capitalize from '../../shared/general/services/Formatter'

interface ISharePopup {
  width : number
  height : number
}

@Component({
  name: 'TheSocialShareBar',
  components: {
    BaseIcon: () => import('../base/BaseIcon.vue'),
    BaseGridLayout: () => import('./BaseGridLayout.vue'),
    SeparationLine: () => import('../SeparationLine.vue'),
  },
})
export default class TheSocialShareBar extends Vue {
  @Prop({ default: () => [] }) networks! : string[]

  private popup : ISharePopup = { width: 626, height: 426 }

  private icons : Record<string, string> = {
    facebook: 'facebook',
    pinterest: 'pinterest',
    whatsapp: 'whatsapp',
    instagram: 'instagram',
    linkedin: 'linkedin',
    twitter: 'x',
    email: 'envelope',
    weibo: 'weibo',
    wechat: 'weixin',
    xing: 'xing',
    youtube: 'youtube',
    yelp: 'yelp',
  }

  created () {
    window.addEventListener('resize', this.recalculatePopupSize)
    this.recalculatePopupSize()
  }

  private get sharePageLabel () : string {
    return `${globalLabelAsString('share_page_label')}:`
  }

  private get socialSharingData () : ISocialSharingData {
    return this.$store.state.SocialSharing
  }

  private get displaySocialShareBar () : boolean {
    return this.socialSharingData.displaySocialShareBar && !!this.networks.length
  }

  private recalculatePopupSize () : void {
    const { innerWidth, innerHeight } = window
    const width = Math.floor(innerWidth / 1.2)
    const height = Math.floor(innerHeight / 1.2)
    this.popup = { width, height }
  }

  private getIconType (key : string) : 'solid' | 'brands' {
    return key === 'email' ? 'solid' : 'brands'
  }

  private capitalizeFirstLetter (value : string) : string {
    return capitalize(value)
  }
}
